import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { microBrand } from './brand';
import './auth-ambient.scss';
/** No decoration around identity verification. */
const EXCLUDED_PATHS = ['/identity-verification'];
/**
 * Static brand background for public pages: one soft glow plus a still grain, in the spirit of the
 * React Bits Grainient. Pure CSS: no canvas, no WebGL, no animation. Also gives the borderless shared
 * inputs a visible edge and focus ring on these pages.
 */
export const AuthAmbient = ({ children }) => {
    const { pathname } = useLocation();
    if (EXCLUDED_PATHS.some((path) => pathname.startsWith(path))) {
        return _jsx(_Fragment, { children: children });
    }
    const style = {
        '--aa-tint': microBrand.tint,
        '--aa-top': microBrand.ambientTop,
        '--aa-bottom': microBrand.ambientBottom,
        '--aa-focus': microBrand.focus
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'auth-ambient', style: style, "aria-hidden": 'true' }), _jsx("div", { className: 'auth-ambient__content', style: style, children: children })] }));
};
